<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/DateTime/NewDDateTimePreview'
export default {
  name: 'NewDOfflineTimePreview',
  extends: compoment
}
</script>
